import { render, staticRenderFns } from "./MamTransferHistory.vue?vue&type=template&id=4ffd1841&scoped=true"
import script from "./MamTransferHistory.vue?vue&type=script&lang=js"
export * from "./MamTransferHistory.vue?vue&type=script&lang=js"
import style0 from "./MamTransferHistory.vue?vue&type=style&index=0&id=4ffd1841&prod&lang=scss&scoped=true"
import style1 from "./MamTransferHistory.vue?vue&type=style&index=1&id=4ffd1841&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd1841",
  null
  
)

export default component.exports